import { render, staticRenderFns } from "./ManageMyTemplate.vue?vue&type=template&id=1f35baae"
import script from "./ManageMyTemplate.vue?vue&type=script&lang=js"
export * from "./ManageMyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports